// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topic__summary{display:block}.topic__summary .wcc-video{border-radius:0}.topic__summary .wcc-youtube-video,.topic__summary .wcc-vimeo-video{border:none}.topic-summary__body{display:flex;flex-direction:column;gap:4px}", ""]);
// Exports
module.exports = exports;
